import React from 'react';

export function ParseError(error) {
    if (error.match('&laquo;')){
        error = error.split('&laquo;').join(String.fromCharCode(171));
    }
    if (error.match('&raquo;')){
        error = error.split('&raquo;').join(String.fromCharCode(187));
    }
    return textToHtml(error);
}

export function textToHtml(html, isWordWrap = false)
{
    if (!html)
        return html;
    const regExp = !isWordWrap ? /<br\s*\/?>/i : /<br\s*\/?>|\n/i,
        arr = html.split(regExp);
    return arr.reduce((el, a, key) => el.concat(a, <br key={key} />), []);
}